import React from 'react';
import { Input, Button, Icon } from 'antd';
import { ordenarAlfabeticament } from '../../commons/ordenacio';

const valorsPerDefecteFiltre = {
    filterDropdownVisible: false,
    searchText: '',
    filtered: false
};

export const paginacioPerDefecte = 14;

export const ordenarAttribut = (itemA, itemB, attribut, tipus) => {
    if (!itemA[attribut]) return 1;
    if (!itemB[attribut]) return -1;

    // En alguns casos, si el filtratge està activat, l'item pot ser un element de React (un span)
    const nomA = typeof itemA[attribut] === 'string' ? itemA[attribut] : itemA[attribut].props.text;
    const nomB = typeof itemB[attribut] === 'string' ? itemB[attribut] : itemB[attribut].props.text;

    // Per defecte s'ordena alfabèticament
    if (tipus === undefined) {
        const itemASenseAccentsIMinusules = nomA.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        const itemBSenseAccentsIMinusules = nomB.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        return ordenarAlfabeticament(itemASenseAccentsIMinusules, itemBSenseAccentsIMinusules);
    }

    // Ordenació per data (s'evita utilitzar moment per problemes de rendiment)
    if (tipus === 'date') {
        const nomAInvertit = nomA.split('-').reverse().join();
        const nomBInvertit = nomB.split('-').reverse().join();

        return ordenarAlfabeticament(nomAInvertit, nomBInvertit);
    }

    return 0;
};

const obtenirFiltresPerDefecte = (columnesAmbFiltres) => {
    let filtres = {};
    columnesAmbFiltres.forEach((item) => {
        filtres[item] = { ...valorsPerDefecteFiltre };
    });
    return filtres;
};

export const obtenirEstatPerDefecte = (data, columnesAmbFiltres) => {
    return { data, filtres: obtenirFiltresPerDefecte(columnesAmbFiltres), paginacio: paginacioPerDefecte };
};

const canviDeTextDeCerca = (e, item, state, setState) => {
    setState({
        ...state,
        filtres: {
            ...state.filtres,
            [item]: { ...state.filtres[item], searchText: e.target.value }
        }
    });
};

export const realitzarCerca = (item, data, searchText, columnesAmbFiltres, setState) => {
    const reg = new RegExp(searchText, 'gi');

    const construirDataAmbTextDestacat = data.map((record, index) => {
        if (!record[item]) {
            return null;
        }
        const match = record[item].match(reg);
        if (!match) {
            return null;
        }
        return {
            ...record,
            [item]: (
                <span text={record[item]}>
                    {record[item].split(reg).map((text, i) => (
                        i > 0 ? [<span className='taula-desplegable-filtre-text-destacat' key={index}>{match[0]}</span>, text] : text                    ))}
                </span>
            )
        };
    }).filter(record => !!record);

    setState(() => {
        return {
            filtres: {
                ...obtenirFiltresPerDefecte(columnesAmbFiltres),
                [item]: {
                    searchText,
                    filterDropdownVisible: false,
                    filtered: !!searchText
                }
            },
            data: construirDataAmbTextDestacat
        };
    });
};

export const obtenirFiltreDesplegable = (item, state, setState, realitzaCerca) => {
    return <div className='taula-desplegable-filtre'>
        <Input
            ref={ele => this[item] = ele}
            placeholder="Cerca..."
            value={state.filtres[item].searchText}
            onChange={(e) => canviDeTextDeCerca(e, item, state, setState)}
            onPressEnter={() => realitzaCerca(item)}
        />
        <Button type='primary' icon='search' size='small' shape='circle' onClick={() => realitzaCerca(item)} />
    </div>;
};

export const obtenirFiltreIcona = (item, state) => {
    return <Icon type='filter' style={{ color: state.filtres[item].filtered ? '#108ee9' : '#aaa' }} />;
};

export const obtenirFiltreDesplegableVisible = (item, state) => {
    return state.filtres[item].filterDropdownVisible;
};


export const obtenirFiltreCanviarDesplegableVisible = (item, visible, setState) => {
    setState(
        prevState => {
            return {
                ...prevState,
                filtres: {
                    ...prevState.filtres,
                    [item]: {
                        ...prevState.filtres[item],
                        filterDropdownVisible: visible
                    }
                }
            };
        },
        () => this[item] && this[item].focus()
    );
};

export const seleccionarPaginacio = (paginacio, setState) => {
    setState(prevState => { return { ...prevState, paginacio }; });
};

export const modificarColumnesBooleanesPerTextSiNo = (data, textCert = 'Sí', textFals = 'No') => {
    const keys = Object.keys(data[0]);
    return data.map(item => {
        const newItem = { ...item };
        keys.forEach(key => {
            if (typeof newItem[key] === 'boolean') {
                newItem[key] ? newItem[key] = textCert : newItem[key] = textFals;
            }
        });
        return newItem;
    });
};



// WEBPACK FOOTER //
// ./src/components/commons/taulaOrdenacioCerca.js